module.exports = __webpack_public_path__ + "img/measurement_info_back_crotch.d307aab2.jpg";